<template>
    <Game region="trung" :re-bet="reBet" />
</template>

<script>
import Game from '@/components/Game/Game';
export default {
    components: { Game },
    props: {
        reBet: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>

<style scoped></style>
